import { Container, Grid, Typography } from "@mui/material";
import ExperiencesCard from "../components/ExperiencesCard";
import experiences from "../data/experiences";

export default function Experiences() {
  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>Expériences</Typography>
      <Grid container spacing={2}>
        {experiences.map((exp) => (
          <ExperiencesCard key={exp.slug} p={exp} />
        ))}

      </Grid>
    </Container>
  );
}
